import ButtonRow from 'lib/src/components/button/ButtonRow';
import LinkButton from '@components/button/LinkButton';
import DataCheck from 'lib/src/components/common/DataCheck';
import Table from 'lib/src/components/table/Table';
import { siteNames } from 'lib/src/shared/enums/site';
import { Column } from 'lib/src/types/table';
import { isEmpty } from 'lib/src/utils/generic';
import { ChallengeGroup } from 'src/types/shared/ChallengeGroup';
import useFetchChallengeGroups from './hooks/useFetchChallengeGroups';
import { userRoles } from 'lib/src/shared/enums/dropdownEnums';
import { getDecodedJwtToken } from 'lib/src/utils/jwt';

const ChallengeGroupsTable = () => {
    const { challengeGroups, isFetching, fetchError } = useFetchChallengeGroups();
    const jwt = getDecodedJwtToken();
    const isSuperAdmin = jwt?.roles.includes(userRoles.superAdmin);

    const columns: Column<ChallengeGroup>[] = [
        {
            key: 1,
            heading: 'Name',
            getValue: row => `${row.name}`,
            searchable: true,
        },
        {
            key: 2,
            heading: 'Permitted admins',
            getValue: row => row.permittedAdmins.map(user => user.name).join(', '),
            searchable: true,
        },
        {
            key: 3,
            heading: 'Permitted viewers',
            getValue: row => row.permittedViewers.map(user => user.name).join(', '),
            searchable: true,
        },
        {
            key: 4,
            heading: 'Can edit?',
            getValue: row => <i className={`fas fa-${row.canEdit ? 'check' : 'times'}`} />,
        },
        {
            key: 5,
            heading: 'Site permissions',
            getValue: row => siteNames[row.site],
        },
        {
            key: 6,
            heading: '',
            getValue: row => {
                const endpoint = `/challenge-groups/${row.id}`;
                return (
                    <>
                        <ButtonRow alignment="right">
                            {row.canView && (
                                <LinkButton
                                    color="green"
                                    icon="search"
                                    href={endpoint + '/challenges'}
                                >
                                    View Challenges
                                </LinkButton>
                            )}
                            {row.canEdit && isSuperAdmin && (
                                <>
                                    <LinkButton
                                        color="yellow"
                                        icon="pencil"
                                        href={`/challenge-groups/edit/${row.id}`}
                                    >
                                        Edit
                                    </LinkButton>
                                    <LinkButton
                                        color="red"
                                        icon="trash"
                                        href={`/challenge-groups/delete/${row.id}`}
                                    >
                                        Delete
                                    </LinkButton>
                                </>
                            )}
                        </ButtonRow>
                    </>
                );
            },
        },
    ];

    return (
        <DataCheck
            dataExists={!isEmpty(challengeGroups)}
            isFetching={isFetching}
            noDataMessage="No Challenge Groups found"
            error={fetchError}
        >
            <Table columns={columns} rows={challengeGroups} pageSizes={[50, 100, 250]} />
        </DataCheck>
    );
};

export default ChallengeGroupsTable;
